import getUrl from "@/Helpers/BaseUrl";
import { Appointment } from "@/types/Api/appointment";
import { Relation } from "@/types/Api/relation";
import { Todo } from "@/types/Api/todo";
import axios from "axios";
import _ from "lodash";
import { b64toBlob } from "@/Helpers/Base64ToBlob";
export async function searchRelations(query, page, pageSize, myRelations) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/search?q=${query}&startPage=${page}&Count=${pageSize}&myRelations=${myRelations}`));
    return _.map(response.data, rel => new Relation(rel));
}
export async function getRelationDetails(relationId) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/${relationId}`));
    return new Relation(response.data);
}
export async function GetRelationAppointments(relationId, page, pageSize) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/${relationId}/Appointments?startPage=${page}&Count=${pageSize}`));
    return _.map(response.data, app => new Appointment(app));
}
export async function GetRelationTodos(relationId, page, pageSize) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/${relationId}/Todos?startPage=${page}&Count=${pageSize}`));
    return _.map(response.data, app => new Todo(app));
}
export async function GetRelationContacts(relationId) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/${relationId}/Contacts`));
    return response.data;
}
export async function getAllRelations(page, pageSize) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/All?startPage=${page}&Count=${pageSize}`));
    return _.map(response.data, rel => new Relation(rel));
}
export async function getMyRelations(page, pageSize) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/My?startPage=${page}&Count=${pageSize}`));
    return _.map(response.data, rel => new Relation(rel));
}
export async function GetRelationReports() {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/reports`));
    return response.data;
}
export async function GetRelationLocations(mine) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/Locations?mine=${mine}`));
    return response.data;
}
export async function SaveRelationReport(id, reportId, scope) {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Relation/${id}/report/${reportId}?scope=${scope}`));
    if (response.data) {
        const decoded = b64toBlob(response.data.Data, 'application/pdf');
        return decoded;
    }
    return undefined;
}
